export const generateTextElement = (text: string): HTMLDivElement => {
  var divElement = document.createElement("div");
  divElement.style.position = "absolute";
  divElement.style.font = "12px Lars";
  divElement.style.backgroundColor = "rgb(255,255, 255)";
  divElement.style.borderRadius = "12px";
  divElement.style.paddingTop = "4px";
  divElement.style.paddingBottom = "4px";
  divElement.style.paddingLeft = "8px";
  divElement.style.paddingRight = "8px";
  divElement.style.userSelect = "none";
  divElement.style.cursor = "default";
  divElement.innerHTML = text;

  return divElement;
};
